import { CiCircleCheck, CiLock } from "react-icons/ci";
import { FaChartLine } from "react-icons/fa";
import { IoKeyOutline } from "react-icons/io5";
import { MdOutlineGeneratingTokens } from "react-icons/md";
import { RiShoppingCart2Line } from "react-icons/ri";

const data = [
  {
    icon: <RiShoppingCart2Line />,
    title: "1. Transaction Initiation",
    description: `Transaction Initiation
Item Listed → Buyer Confirms Purchase
Behavior recorded as pending trust event`,
  },
  {
    icon: <CiLock />,
    title: "2. On-Chain Escrow Lock",
    description: `On-Chain Escrow Lock
Payment Locked in Smart Contract
Funds held until completion
No platform custody
`,
  },
  {
    icon: <CiCircleCheck />,
    title: "3. Completion & Validation",
    description: `Completion & Validation
Item Received → Confirmation Signed
Auto-release triggers next state`,
  },
  {
    icon: <MdOutlineGeneratingTokens />,
    title: "4. Reputation SBT Issuance",
    description: `Reputation SBT Issuance
Soulbound Reputation Token Minted
Non-transferable / tamper-proof
Trust permanently owned by user/`,
  },
  {
    icon: <IoKeyOutline />,
    title: "5. Access & Privilege Unlock",
    description: `Access & Privilege Unlock
New permissions activated
•Higher selling limits
•Local community access
•Future DAO eligibility`,
  },
  {
    icon: <FaChartLine />,
    title: "6. Iterative Trust Growth",
    description: `Iterative Trust Growth
Repeated behavior → stronger trust
System becomes safer over time`,
  },
];

export default function Section5() {
  return (
    <section className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <div className="flex overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-2 lg:grid-cols-3 gap-8 pb-4 md:pb-0 scrollbar-hide -mx-4 px-4 md:mx-0 md:px-0">
          {data.map((item, index) => (
            <div
              key={index}
              className="flex flex-col items-center gap-4 py-8 px-4 rounded-lg border border-white bg-black text-white w-[calc(100vw-2rem)] md:w-auto flex-shrink-0 snap-start md:snap-none"
            >
              <div className="w-16 h-16 text-[24px] bg-white text-black rounded-lg flex items-center justify-center">
                {item.icon}
              </div>
              <h4 className="text-[18px] font-bold text-center">
                {item.title}
              </h4>
              <p className="text-[14px] text-left leading-relaxed whitespace-pre-line text-center">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
